<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <div class="left300 right-20">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="ptitle">门店管理</span>
                </div>
                <div
                    v-for="(item, index) in brandLists"
                    class="listitem"
                    :key="index"
                    :class="{ activelist: active == item.id, listitem: true }"
                    @click="selectBrand(item)"
                >
                    <!-- <i class="fa fa-fire el-danger"></i> -->
                    &nbsp;&nbsp;{{ item.name }}
                </div>
            </el-card>
        </div>
        <div class="contentMode">
            <el-card class="box-card2">
                <div slot="header" class="clearfix">
                    <span class="ptitle">门店列表</span>

                    <el-button
                        class="pull-right"
                        icon="el-icon-upload"
                        type="primary"
                        size="mini"
                        v-if="!isMaxStoreNum"
                        @click="fileUploadTemp"
                        >批量导入</el-button
                    >
                    <el-button
                        class="pull-right right-10"
                        icon="el-icon-upload"
                        type="primary"
                        size="mini"
                        @click="downloadFile"
                        >模板下载</el-button
                    >
                    <el-button
                        class="pull-right right-10"
                        icon="el-icon-download"
                        size="mini"
                        @click="exportData"
                        >导出门店</el-button
                    >
                    <el-button
                        class="pull-right"
                        icon="fa fa-home"
                        size="mini"
                        :disabled="isDisabled"
                        v-if="isGranted('Pages.BussinessStoreInfos.EditBatch')"
                        @click="storeSetting"
                        >门店设置</el-button
                    >
                    <el-button
                        class="pull-right right"
                        icon="el-icon-document"
                        size="mini"
                        @click="quickSync"
                        v-if="
                            isGranted('Pages.BussinessStoreInfos.Create') &&
                            !isMaxStoreNum
                        "
                        >同步门店</el-button
                    >
                    <el-button
                        class="pull-right"
                        icon="el-icon-plus"
                        size="mini"
                        @click="newStore"
                        v-if="
                            isGranted('Pages.BussinessStoreInfos.Create') &&
                            !isMaxStoreNum
                        "
                        >新增门店</el-button
                    >
                    <el-button
                        icon="el-icon-back"
                        type="primary"
                        class="pull-right right"
                        @click="backTo"
                        size="mini"
                        >返回</el-button
                    >

                    <div class="pull-right right-20">
                        <el-input
                            placeholder="请输入门店编码或名称"
                            prefix-icon="el-icon-search"
                            v-model="queryParam.storeName"
                            size="mini"
                        ></el-input>
                    </div>
                    <el-select
                        v-model="queryParam.status"
                        class="pull-right right-10"
                        placeholder="请选择状态"
                        size="mini"
                        filterable
                        clearable
                    >
                        <el-option
                            v-for="item in statusList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                    <span class="pull-right left-10">状态:</span>
                </div>
                <el-col :lg="18" :md="20" :sm="20" :xs="24" v-show="!visible">
                    <p><i class="el-icon-menu right-20"></i>核算规则设置</p>

                    <el-form
                        :label-position="labelPosition"
                        label-width="130px"
                        class="idadmin"
                        :model="setModel"
                        :rules="rules"
                        ref="refBatchForm"
                    >
                        <el-form-item label="当前选择门店">
                            <div class="batch-store-tools">
                                <el-button
                                    size="mini"
                                    type="text"
                                    icon="el-icon-check"
                                    @click="selectAllStores"
                                    >全选门店</el-button
                                >
                                <el-button
                                    size="mini"
                                    type="text"
                                    icon="el-icon-close"
                                    @click="clearSelectStores"
                                    >清空选择</el-button
                                >
                            </div>
                            <treeselect
                                :value-consists-of="valueConsistsOf"
                                v-model="SelStoreIds"
                                :multiple="true"
                                :options="storeTreeData"
                                :limit="30"
                                :limit-text="limitText"
                                placeholder
                                class="font-14"
                            />
                        </el-form-item>

                        <el-form-item label="账套" prop="accountConfID">
                            <el-select
                                v-model="setModel.accountConfID"
                                filterable
                                default-first-option
                                style="width: 100%"
                                placeholder="请选中所用账套"
                            >
                                <el-option
                                    v-for="item in AccountList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    :disabled="item.isOverdue"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="周期">
                            <el-select
                                v-model="setModel.cycle"
                                filterable
                                default-first-option
                                style="width: 100%"
                                placeholder="请选中传输周期"
                                v-show="isPos"
                            >
                                <el-option
                                    v-for="item in EnumCycle"
                                    :key="item.id"
                                    :label="item.content"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="科目分组编码"
                            prop="subjectGroupCode"
                        >
                            <el-input
                                v-model="setModel.subjectGroupCode"
                            ></el-input>
                            <span>当财务软件使用多个会计科目分组时填写</span>
                        </el-form-item>
                        <el-form-item
                            label="凭证字"
                            prop="VoucherGroup"
                            v-if="isSameAccount"
                        >
                            <el-select
                                v-model="setModel.voucherGroup"
                                filterable
                                style="width: 100%"
                                placeholder="请选择凭证字"
                                clearable
                            >
                                <el-option
                                    v-for="item in VoucherGroupList"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-button
                            type="info"
                            size="medium"
                            @click="setClose"
                            icon="el-icon-close"
                            >关闭</el-button
                        >
                        <el-button
                            type="primary"
                            size="medium"
                            :loading="setSaving"
                            @click="setSubmit"
                            icon="el-icon-check"
                            >保存</el-button
                        >
                    </el-form>
                </el-col>
                <el-col :span="24" v-show="visible">
                    <!--门店列表-->
                    <el-table
                        :data="storeTableData"
                        border
                        size="mini"
                        ref="storeTableData"
                        @select="tableSelectHandler"
                        @select-all="tableSelectAllHandler"
                    >
                        <el-table-column
                            type="selection"
                            width="55"
                        ></el-table-column>

                        <el-table-column label="操作" width="90">
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="top">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        v-if="
                                            isGranted(
                                                'Pages.BussinessStoreInfos.Edit'
                                            ) && !scope.row.isOverdue
                                        "
                                        @click="
                                            editStoreRow(
                                                scope.$index,
                                                scope.row
                                            )
                                        "
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除" placement="top">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        v-if="
                                            isGranted(
                                                'Pages.BussinessStoreInfos.Delete'
                                            ) && !scope.row.isOverdue
                                        "
                                        @click="
                                            deleteStoreRow(
                                                scope.$index,
                                                scope.row
                                            )
                                        "
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            label="门店名称"
                            width="170"
                        ></el-table-column>
                        <el-table-column
                            prop="storeCode"
                            label="门店编号"
                        ></el-table-column>
                        <el-table-column label="到期时间">
                            <template slot-scope="scope">{{
                                timeFormat(scope.row.endTime)
                            }}</template>
                        </el-table-column>
                        <el-table-column label="距离天数">
                            <template slot-scope="scope">{{
                                remainDays(
                                    scope.row.startTime,
                                    scope.row.endTime
                                )
                            }}</template>
                        </el-table-column>
                        <el-table-column label="状态">
                            <template slot-scope="scope">
                                <i
                                    :class="statusColor(scope.row)"
                                    style="margin-right: 10px"
                                ></i>
                                {{ statusFormat(scope.row) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="acctName"
                            label="账套名称"
                        ></el-table-column>
                        <el-table-column
                            prop="checkMethodAddr"
                            label="核算地址"
                        ></el-table-column>
                        <el-table-column
                            prop="acctID"
                            label="账套号"
                        ></el-table-column>
                        <!-- <el-table-column label="参数" width="360">
                            <template slot-scope="scope">{{
                                paramFormat(scope.row.paramData)
                            }}</template>
                        </el-table-column> -->
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="storeDataApiUrl"
                        :GetData="getStoreData"
                        :queryParam="queryParam"
                        :isInit="false"
                    ></pagerBar>

                    <el-table
                        id="storeExportData"
                        ref="detail"
                        size="mini"
                        hidden
                        :data="storeExportTableList"
                    >
                        <el-table-column
                            prop="name"
                            label="门店名称"
                        ></el-table-column>
                        <el-table-column
                            prop="storeCode"
                            label="门店编号"
                        ></el-table-column>
                        <el-table-column
                            prop="subjectGroupCode"
                            label="科目分组编码"
                        ></el-table-column>
                        <el-table-column
                            prop="subjectUseOrg"
                            label="科目使用组织"
                        >
                        </el-table-column>
                    </el-table>
                </el-col>
                <storeQuickSync
                    ref="storeQuickSync"
                    :Refresh="Refresh"
                ></storeQuickSync>
            </el-card>
        </div>
        <!-- 批量导入Dialog开始 -->
        <uploadTemp
            :apiURL="uploadUrl"
            ref="refFileUpload"
            :Refresh="Refresh"
            :OtherParams="OtherParams"
        ></uploadTemp>
        <!-- 批量导入Dialog结束 -->
        <el-dialog
            v-el-drag-dialog
            :title="xtitle"
            :visible.sync="homeVisible"
            width="35%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                :label-position="labelPosition"
                label-width="100px"
                :model="storeModel"
                :rules="rules"
                ref="refStoreForm"
            >
                <el-form-item label="名称" prop="name">
                    <el-input
                        v-model="storeModel.name"
                        placeholder="请输入门店名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="编号" prop="storeCode">
                    <el-input
                        v-model="storeModel.storeCode"
                        placeholder="请输入门店编号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="账套" prop="AccountConfID">
                    <el-select
                        v-model="storeModel.accountConfID"
                        filterable
                        default-first-option
                        style="width: 100%"
                        placeholder="请选中所用账套"
                        @change="accountChange"
                    >
                        <el-option
                            v-for="item in AccountList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            :disabled="item.isOverdue"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="周期">
                    <el-select
                        v-model="storeModel.cycle"
                        filterable
                        default-first-option
                        style="width: 100%"
                        placeholder="请选中传输周期"
                        v-show="isPos"
                    >
                        <el-option
                            v-for="item in EnumCycle"
                            :key="item.id"
                            :label="item.content"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="科目分组编码" prop="subjectGroupCode">
                    <el-input v-model="storeModel.subjectGroupCode"></el-input>
                    <span>当财务软件使用多个会计科目分组时填写</span>
                </el-form-item>
                <el-form-item label="科目使用组织" prop="subjectUseOrg">
                    <el-input v-model="storeModel.subjectUseOrg"></el-input>
                    <span>当财务软件使用多组织时填写</span>
                </el-form-item>
                <el-form-item label="凭证字" prop="VoucherGroup">
                    <el-select
                        v-model="storeModel.voucherGroup"
                        filterable
                        clearable
                        style="width: 100%"
                        placeholder="请选择凭证字"
                    >
                        <el-option
                            v-for="item in VoucherGroupList"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="info"
                    size="medium"
                    @click="homeVisible = false"
                    icon="el-icon-close"
                    >关闭</el-button
                >
                <el-button
                    type="primary"
                    size="medium"
                    @click="saveStore"
                    icon="el-icon-check"
                    >保存</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import treeselect from '@riophae/vue-treeselect'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
import uploadTemp from '@/views/batchUploadTemp/uploadTemp'
import storeQuickSync from '../initialization/storeQuickSync'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import moment from 'moment'

export default {
    components: {
        treeselect,
        pagerBar,
        uploadTemp,
        storeQuickSync
    },
    data() {
        return {
            statusList: [
                { id: 2, name: '即将过期' },
                { id: 4, name: '有效' }
            ],
            storeExportTableList: [],
            valueConsistsOf: 'LEAF_PRIORITY',
            isMaxStoreNum: false,
            OtherParams: {
                brandID: '',
                accountID: '',
                moduleConfID: ''
            },
            isPos: true, //是否是POS模块
            isDisabled: false,
            openloading: true,
            exportDataToExcelUrl:
                config.BASE_Middle_API + 'BussinessStoreInfo/ExcelOutPut',

            storeDataApiUrl:
                config.BASE_Middle_API + 'BussinessStoreInfo/GetListByPage',
            storeApiUrl: config.BASE_Middle_API + 'BussinessStoreInfo',
            uploadUrl: config.BASE_Middle_API + 'FileUpload/UploadFileStore',
            brandLists: [],
            active: '', // 代码高亮
            dialogVisible: false,
            visible: true,
            uploadVisible: false,
            homeVisible: false,
            selStore: [], //选中的门店
            selStoreIds: [], //选中的门店ID集合
            moduleConfID: 1, //模块ID
            xtitle: '',
            storeTreeData: [],
            pagerTotal: 0,
            pagerSize: 10,
            currentPage: 1,
            queryParam: { BrandID: '', storeName: '', status: '' },
            currentBrandID: '', //当前选中的品牌ID
            isCreateStore: false, //是否可以新增门店
            brandAcctID: '', //品牌的默认账套号
            operation: '', //当前操作是新增or修改
            storeTableData: [], //门店列表数据
            AccountList: [], //账套数据
            VoucherGroupList: [], // 凭证字列表
            EnumCycle: [], //传输周期
            labelPosition: 'left',
            setModel: {
                accountConfID: '',
                cycle: ''
            },
            setSaving: false, //批量设置保存中
            isSameAccount: false,
            storeModel: {
                id: 0,
                name: '',
                accountConfID: '',
                storeCode: '',
                brandID: '',
                cycle: -1,
                subjectGroupCode: '',
                voucherGroup: '',
                subjectUseOrg: ''
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请选择门店名称',
                        trigger: 'blur'
                    }
                ],
                accountConfID: [
                    { required: true, message: '请选择账套', trigger: 'change' }
                ],
                storeCode: [
                    {
                        required: true,
                        message: '请输入门店编号',
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    mounted: function () {
        this.getRouteParam()
        this.getBrandData()
        this.checkStoreNum()
    },
    computed: {
        SelStoreIds: {
            get() {
                let Ids = []
                this.selStore.forEach((element) => {
                    Ids.push(Number(element.id))
                })
                return Ids
            },
            set(newValue) {
                this.selStoreIds = newValue
                return newValue
            }
        }
    },
    methods: {
        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        remainDays(start, end) {
            const nowDate = moment().format('YYYY-MM-DD')
            const nowDays = moment(nowDate).diff(
                moment(start).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                const daysone =
                    moment(end).diff(
                        moment(start).format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                return daysone
            } else {
                const days =
                    moment(end).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                if (days <= 0) {
                    return '0'
                }
                return days
            }
        },
        statusFormat(item) {
            const nowDate = moment().format('YYYY-MM-DD')
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                return '未启用'
            } else {
                const days =
                    moment(item.endTime).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1 //结束时间算一天 需+1
                if (days < 30 && days > 0) {
                    return '即将到期'
                } else if (days <= 0) {
                    return '过期失效'
                } else {
                    return '有效'
                }
            }
        },
        statusColor(item) {
            const nowDate = moment().format('YYYY-MM-DD') //获取当前时间 排除时分秒 按整天
            const nowDays = moment(nowDate).diff(
                moment(item.startTime).format('YYYY-MM-DD'),
                'days'
            )
            if (nowDays < 0) {
                return 'fa fa-circle el-info'
            } else {
                const days =
                    moment(item.endTime).diff(
                        new moment().format('YYYY-MM-DD'),
                        'days'
                    ) + 1
                if (days < 30 && days > 0) {
                    return 'fa fa-circle el-warning'
                } else if (days <= 0) {
                    return 'fa fa-circle el-danger'
                } else {
                    return 'fa fa-circle el-success'
                }
            }
        },
        accountChange(val) {
            this.storeModel.accountConfID = val
            this.storeModel.voucherGroup = ''
            this.getVoucherGroupList(val)
        },
        exportData() {
            const _this = this
            AjaxHelper.post(_this.exportDataToExcelUrl, _this.queryParam)
                .then((res) => {
                    if (res.success) {
                        _this.storeExportTableList = res.result
                        if (_this.storeExportTableList.length <= 0) {
                            _this.$notify({
                                title: '提示',
                                message: '当前无可导出的门店数据',
                                type: 'error',
                                position: 'bottom-right'
                            })
                            return false
                        } else {
                            _this.$nextTick(function () {
                                _this.downExcel()
                            })
                        }
                    }
                })
                .catch(function (error) {})
        },
        downExcel() {
            /* 从表生成工作簿对象 */
            let fix = document.querySelector('.el-table__fixed')
            let wb
            var xlsxParam = { raw: true }
            if (fix) {
                //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#storeExportData').removeChild(fix),
                    xlsxParam
                )
                document.querySelector('#storeExportData').appendChild(fix)
            } else {
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#storeExportData'),
                    xlsxParam
                )
            }
            /* 获取二进制字符串作为输出 */
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            })
            try {
                const fileName = '门店批量导出.xlsx' //下载文件名称
                FileSaver.saveAs(
                    //Blob 对象表示一个不可变、原始数据的类文件对象。
                    //Blob 表示的不一定是JavaScript原生格式的数据。
                    //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
                    //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
                    new Blob([wbout], { type: 'application/octet-stream' }),
                    //设置导出文件名称
                    fileName
                )
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout)
            }
            return wbout
        },
        backTo() {
            this.$router.push({
                path: '/initialization/userVersion'
            })
        },
        checkStoreNum() {
            const _this = this
            AjaxHelper.get(_this.storeApiUrl + '/GetIsOverMaxNum', {
                moduleConfID: _this.moduleConfID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.isMaxStoreNum = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        quickSync() {
            const _this = this
            _this.$refs.storeQuickSync.openSelect(
                _this.currentBrandID,
                _this.moduleConfID
            )
        },
        fileUploadTemp() {
            this.$refs.refFileUpload.open()
        },
        getRouteParam() {
            const _this = this
            //判断是否存在参数信息
            if (!$.isEmptyObject(_this.$route.query)) {
                //判断是新建修改还是查看
                _this.moduleConfID = _this.$route.query.moduleConfID
                _this.getAccountData()
                _this.getEnumsCycle()
            } else {
                _this.$router.push({
                    path: '/initialization/userVersion'
                })
            }
        },
        getVoucherGroupList(accountID) {
            const _this = this
            AjaxHelper.get(_this.storeApiUrl + '/GetVoucherGroupList', {
                accountId: accountID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.VoucherGroupList = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getEnumsCycle() {
            const _this = this
            AjaxHelper.get(_this.storeApiUrl + '/GetEnumsCycle', {})
                .then(function (response) {
                    if (response.success) {
                        _this.EnumCycle = response.result
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        paramFormat(params) {
            let paramsObj = JSON.parse(params)
            let format_Str = ''
            paramsObj.forEach((x) => {
                format_Str += x.name + ':' + x.value + ','
            })
            let reg = /,$/gi
            format_Str = format_Str.replace(reg, '')
            return format_Str
        },
        getAccountData() {
            //获取账套数据
            const _this = this
            AjaxHelper.get(_this.storeApiUrl + '/GetAccountData', {
                moduleConfID: _this.moduleConfID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.AccountList = response.result
                        _this.setModel.accountConfID = _this.AccountList[0].id
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getBrandData() {
            //获取品牌数据
            const _this = this
            AjaxHelper.get(_this.storeApiUrl + '/GetBrandList', {
                moduleConfID: _this.moduleConfID
            })
                .then(function (response) {
                    if (response.success) {
                        _this.brandLists = response.result
                        if (response.result.length > 0) {
                            //返回值存在 则默认选中第一条门店
                            const firstItem = response.result[0]
                            _this.selectBrand(firstItem)
                        }
                        _this.openloading = false
                    }
                })
                .catch(function (error) {
                    console.log(error)
                    _this.$router.push({
                        path: '/initialization/userVersion'
                    })
                })
        },
        downloadFile() {
            this.openloading = true
            let requestConfig = {
                headers: {
                    'Content-Type': 'application/json;application/octet-stream'
                }
            }
            var downloadFileUrl =
                config.BASE_Middle_API + 'FileUpload/DownloadStoreModel'
            AjaxHelper.post(downloadFileUrl, requestConfig, {
                responseType: 'blob'
            }).then((res) => {
                // 处理返回的文件流
                const content = res
                const blob = new Blob([content])
                const fileName = '门店批量上传.xlsx'
                if ('download' in document.createElement('a')) {
                    // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                    this.openloading = false
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                    this.openloading = false
                }
            })
        },
        getStoreData(d) {
            const _this = this
            _this.storeTableData = d
            if (_this.selStore.length) {
                _this.toggleSelection(_this.selStore)
            }
            _this.getAccountData()
        },

        selectBrand(item) {
            //品牌选中
            const _this = this
            _this.active = item.id
            _this.currentPage = 1
            _this.currentBrandID = item.id
            _this.OtherParams.moduleConfID = _this.moduleConfID
            _this.OtherParams.brandID = item.id
            _this.queryParam.BrandID = item.id
            if (item.accountConfID === 0) {
                //如果品牌的配置字段未填写则不能新增门店
                _this.isCreateStore = false
            } else {
                _this.isCreateStore = true
                _this.brandAcctID = item.accountConfID
                _this.OtherParams.accountID = item.accountConfID
                _this.storeModel.accountConfID = item.accountConfID
            }
            this.selStore = []
        },
        initStoreModel() {
            //初始门店数据
            const _this = this
            if (_this.$refs['refStoreForm']) {
                _this.$refs['refStoreForm'].resetFields()
                _this.storeModel = {
                    id: 0,
                    name: '',
                    accountConfID: _this.brandAcctID,
                    storeCode: '',
                    cycle: -1,
                    subjectGroupCode: '',
                    voucherGroup: '',
                    subjectUseOrg: ''
                }
            }
        },
        saveStore() {
            //提交保存
            const _this = this
            this.$refs['refStoreForm'].validate((valid) => {
                if (valid) {
                    let postUrl = ''
                    if (_this.operation == 'Add') {
                        postUrl = '/Add'
                    } else {
                        postUrl = '/Edit'
                    }
                    _this.storeModel.brandID = _this.currentBrandID
                    AjaxHelper.post(
                        _this.storeApiUrl + postUrl,
                        _this.storeModel
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$notify({
                                    title: '成功',
                                    message: '操作成功',
                                    type: 'success',
                                    position: 'bottom-right'
                                })
                                _this.initStoreModel()
                                _this.homeVisible = false
                                _this.Refresh()
                                _this.checkStoreNum()
                            }
                        })
                        .catch(function (error) {
                            console.log(error)
                        })
                }
            })
        },
        deleteStoreRow(index, row) {
            //删除门店
            const _this = this
            this.$confirm('此操作将删除该门店, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    const confirmData = { Id: row.id }
                    AjaxHelper.delete(
                        _this.storeApiUrl + '/Delete',
                        confirmData
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                })
                                _this.Refresh()
                                _this.checkStoreNum()
                            }
                        })
                        .catch(function (error) {})
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        newStore() {
            //新增门店
            const _this = this
            if (_this.currentBrandID === '') {
                this.$notify({
                    title: '提示',
                    message: '请选中品牌后进行新增操作',
                    type: 'error',
                    position: 'bottom-right'
                })
            } else {
                if (_this.isCreateStore) {
                    //品牌的配置参数完整 可以新增
                    _this.initStoreModel()
                    _this.xtitle = '新增门店'
                    _this.homeVisible = true
                    _this.operation = 'Add'
                    _this.getVoucherGroupList(_this.storeModel.accountConfID)
                } else {
                    this.$notify({
                        title: '提示',
                        message: '品牌未进行环境配置操作,无法新增门店',
                        type: 'error',
                        position: 'bottom-right'
                    })
                }
            }
        },
        editStoreRow(index, row) {
            //编辑门店
            const _this = this

            this.xtitle = '编辑门店'
            _this.initStoreModel()
            _this.operation = 'Edit'
            AjaxHelper.get(_this.storeApiUrl + '/GetModel', { id: row.id })
                .then(function (response) {
                    if (response.success) {
                        _this.homeVisible = true
                        _this.storeModel = response.result
                        _this.getVoucherGroupList(
                            _this.storeModel.accountConfID
                        )
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },

        storeSetting() {
            //门店设置
            const _this = this

            AjaxHelper.get(_this.storeApiUrl + '/GetIsSameAccount')
                .then(function (response) {
                    if (response.success) {
                        _this.isSameAccount = response.result
                        if (_this.isSameAccount) {
                            _this.getVoucherGroupList(_this.brandAcctID)
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })

            // this.getStoreTreeData();
            if (_this.currentBrandID == '' || _this.currentBrandID == 0) {
                //_this.isDisabled = true;
                _this.$notify({
                    title: '提示',
                    message: '请先选择品牌',
                    type: 'error',
                    position: 'bottom-right',
                    duration: 2000,
                    onClose: function () {
                        _this.isDisabled = false
                    }
                })
            } else {
                //批量设置的账套默认取当前品牌账套，与品牌配置保持一致，可手动改选其他账套
                _this.setModel.accountConfID = _this.brandAcctID || ''
                AjaxHelper.get(_this.storeApiUrl + '/GetTreeByID', {
                    id: _this.currentBrandID
                })
                    .then(function (response) {
                        if (response.success) {
                            _this.storeTreeData = response.result
                            _this.visible = false
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        },
        limitText(count) {
            //超出limit个标签后的提示文案
            return `还有${count}家门店`
        },
        selectAllStores() {
            //全选：收集树中所有叶子（门店）节点加入选中集合
            const _this = this
            const leaves = []
            const collect = function (nodes) {
                nodes.forEach(function (node) {
                    if (node.children && node.children.length) {
                        collect(node.children)
                    } else {
                        leaves.push(node)
                    }
                })
            }
            collect(_this.storeTreeData)
            leaves.forEach(function (node) {
                if (!_this.selStore.find((item) => item.id === node.id)) {
                    _this.selStore.push(node)
                }
            })
            _this.selStoreIds = _this.selStore.map(function (item) {
                return Number(item.id)
            })
        },
        clearSelectStores() {
            //清空全部门店选择
            this.selStore = []
            this.selStoreIds = []
        },
        setClose() {
            //关闭配置页面
            this.visible = true
            if (this.$refs['refBatchForm']) {
                this.$refs['refBatchForm'].clearValidate()
            }
        },
        setSubmit() {
            //配置提交
            const _this = this
            if (_this.setSaving) return
            this.$refs['refBatchForm'].validate((valid) => {
                if (valid) {
                    let confirmData = {
                        StoreIds: _this.selStoreIds,
                        accountConfID: _this.setModel.accountConfID,
                        cycle: _this.setModel.cycle,
                        subjectGroupCode: _this.setModel.subjectGroupCode,
                        voucherGroup: _this.setModel.voucherGroup
                    }
                    _this.setSaving = true
                    AjaxHelper.post(
                        _this.storeApiUrl + '/EditBatch',
                        confirmData
                    )
                        .then(function (response) {
                            if (response.success) {
                                _this.$notify({
                                    title: '提示',
                                    message: '批量配置成功',
                                    type: 'success',
                                    position: 'bottom-right'
                                })
                                _this.setModel = {
                                    accountConfID: _this.brandAcctID || '',
                                    cycle: ''
                                }
                                _this.selStore = []
                                _this.visible = true
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {
                            console.log(error)
                        })
                        .finally(function () {
                            _this.setSaving = false
                        })
                }
            })
        },
        // 选中table已有数据
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$nextTick(() => {
                        let checked = this.storeTableData.find(
                            (tableRow) => tableRow.id === row.id
                        )
                        this.$refs.storeTableData.toggleRowSelection(checked)
                    })
                })
            } else {
                this.$refs.storeTableData.clearSelection()
            }
        },
        tableSelectHandler(selection, row) {
            const _this = this
            //selection为当前页所有选中行
            let allRows = selection.filter((item) => !!item)
            if (allRows.find((item) => item.id === row.id)) {
                // 选中新增一行
                this.addRows([row])
            } else {
                // 取消删除一行
                this.removeRows([row])
            }
        },
        tableSelectAllHandler(selection) {
            //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
            selection.forEach((e, index) => {
                if (e === undefined) {
                    selection.splice(index, 1)
                }
            })
            // 如果有则是全选否则就是全取消
            if (selection.length > 0) {
                this.addRows(this.storeTableData)
            } else {
                this.removeRows(this.storeTableData)
            }
        },
        // 添加选中行
        addRows(rows) {
            const _this = this
            for (let key of rows) {
                // 如果选中的数据中没有这条就添加进去
                if (!_this.selStore.find((item) => item.id === key.id)) {
                    this.selStore.push(key)
                }
            }
        },
        // 取消选中行
        removeRows(rows) {
            const _this = this
            if (_this.selStore.length > 0) {
                for (let row of rows) {
                    _this.selStore = _this.selStore.filter(
                        (item) => item.id !== row.id
                    )
                }
            }
        },
        handleClose(d) {
            d()
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh()
        }
    }
}
</script>

<style scoped="scoped">
.left300 {
    float: left;
    width: 220px;
}

.contentMode {
    float: left;
    width: -webkit-calc(100% - 240px);
    width: calc(100% - 240px);
}
.idadmin .el-form-item__content {
    line-height: none !important;
}

.noticeDialog h3 span {
    font-size: 13px;
}

.notify_p {
    text-indent: 2em;
    line-height: 2;
    padding: 5px 0;
}
</style>
<style>
.idadmin .el-form-item__content {
    line-height: 20px !important;
}
.batch-store-tools {
    margin-bottom: 5px;
}
</style>
